<!--
 * @Description: 订单信息
 * @Autor: txp
 * @Date: 2021-04-27 18:59:46
-->
<template>
  <div class="orderInfo">
    <!-- <el-scrollbar ref="myScrollbar"
                  style="max-height:400px"
                  wrap-class="content-scrollbar"
                  :native="false"
                  :noresize="false"
                  tag="div"> -->
    <div
      v-for="(items, k) in tableData"
      :key="k"
      :ref="items.key || 'productList'"
    >
      <div>
        <span class="warning-row" v-if="items.calSucessMsg">{{
          items.calSucessMsg
        }}</span>
      </div>
      <el-table
        :show-header="k != 0 ? false : true"
        :header-cell-style="{
          fontSize: '13px',
          color: '#787878',
          background: '#F5F5F5',
          textAlign: 'center',
        }"
        :cell-style="{
          fontSize: '14px',
          padding: '20px 0px',
          textAlign: 'center',
        }"
        :row-key="getRowKey"
        :data="items.data"
        align="center"
        :row-class-name="tableRowClassName"
        tooltip-effect="dark"
        @selection-change="(val) => handleSelectionChange(val)"
        style="border:1px solid #D8D8D8;border-bottom:0px;margin-top:20px;"
      >
        <el-table-column
          label="全选"
          type="selection"
          fixed="left"
          :reserve-selection="true"
          width="55"
        ></el-table-column>
        <el-table-column
          :width="item.props.width"
          :label="item.props.title || item.title"
          v-for="(item, index) in tableList"
          :key="index"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div v-if="item.field === 'productName'">
              <el-popover
                placement="top-start"
                trigger="hover"
                :disabled="!scope.row.calSucessMsg"
                :content="scope.row.calSucessMsg"
              >
                <!-- 本品商品 -->
                <div slot="reference">
                  <p class="overflow_ellipsis2">{{ scope.row.productName }}</p>
                  <p class="mt20">
                    <span>商品编码：</span>
                    <span>{{ scope.row.productCode }}</span>
                  </p>
                </div>
                <!-- <div class="flexs" slot="reference">
                  <div class="">
                    <el-image style="width:90px;height:90px" :src="scope.row.imgUrl"></el-image>
                  </div>
                  <div class="textleft ft14 ml20">
                    <p class="overflow_ellipsis2">{{ scope.row.productName }}</p>
                    <p class="mt20">
                      <span>商品编码：</span>
                      <span>{{ scope.row.productCode }}</span>
                    </p>
                  </div>
                </div> -->
                <!-- 促销商品 -->
                <!-- <div class="flex"
                     v-if="scope.row.lineType === '1'">
                  <div>
                    <el-image style="width:90px;height:90px"
                              :src="scope.row.imgUrl">
                    </el-image>
                  </div>
                  <div class="textleft ml20 ft14 C909090">
                    <p class="overflow_ellipsis2">{{scope.row.productName}}</p>
                  </div>
                </div> -->
              </el-popover>
            </div>
            <div v-else-if="item.field === 'productNum'">
              <div>
                <div v-if="scope.row.lineType === '1'">
                  <el-input-number
                    v-if="scope.row.productNum !== null"
                    size="small"
                    v-model="scope.row.productNum"
                    :max="scope.row.productNum"
                    :min="0"
                    disabled
                    @change="AddorderList"
                    label="数量"
                  ></el-input-number>
                  <div v-else>{{ scope.row.productNum }}</div>
                </div>

                <el-input-number
                  v-else
                  size="small"
                  v-model="scope.row.productNum"
                  :min="1"
                  :disabled="!!scope.row.calSucessMsg || scope.row.disabled"
                  @change="AddorderList"
                  label="数量"
                ></el-input-number>
              </div>
              <!-- 有赠品促销政策情况 -->
              <!-- <div class="h130 ml20 ft14 C909090">无</div> -->
            </div>
            <div
              class="flexs"
              v-else-if="item.field === 'promotionList'"
              style="width:100%;justify-content:center"
            >
              <div
                v-if="scope.row.lineType === '0'"
                @click="checkPromotion(scope, k)"
              >
                <div
                  class="tag-box"
                  v-if="
                    scope.row.promotionList &&
                      scope.row.promotionList.length > 0
                  "
                >
                  <div v-for="(pro, i) in scope.row.promotionList" :key="i">
                    <el-popover
                      placement="top-start"
                      trigger="hover"
                      :disabled="!pro.calSucessMsg"
                      :content="pro.calSucessMsg"
                    >
                      <el-tag
                        size="small"
                        closable
                        :type="pro.calSucessMsg ? 'danger' : 'success'"
                        slot="reference"
                        class="pro-tag"
                        @close="closeTag(scope, k, i)"
                      >
                        {{ pro.promotionName }}
                      </el-tag>
                    </el-popover>
                  </div>
                </div>
                <div v-else>
                  <el-tag>请选择政策</el-tag>
                </div>
              </div>
            </div>
            <div class="flexs" v-else>
              <el-popover
                placement="top-start"
                trigger="hover"
                :disabled="!scope.row.calSucessMsg"
                :content="scope.row.calSucessMsg"
              >
                <span slot="reference">{{ analysisField(scope, item) }}</span>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope" v-if="!scope.row.disabled">
            <div
              v-if="scope.row.lineType !== '1'"
              @click="deleteProduct(scope, k)"
            >
              <div>
                <p class="el-icon-delete cursorP" style="font-size:16px;"></p>
              </div>
              <!-- 有赠品促销政策情况 -->
              <!-- <div class="h130 ml20 ft14 C909090">无</div> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- </el-scrollbar> -->

    <!-- 促销政策右侧弹框 -->
    <ShopsettleReplenDrawer
      :visible.sync="visible"
      :promotionParams="promotionParams"
      :promotionCodes="promotionCodes"
      @submit="onModalOk"
      @handleClose="handleClose"
    />
  </div>
</template>
<script>
import ShopsettleReplenDrawer from './ShopsettleReplenDrawer'
// import PromotionDetail from "./promotionDetail";
import { getTableConfig, getBatchDictSelect, getOrderCal } from '@/api/api'
import { Storage } from '@/utils/storage'
import cals from '../js/cals'
import { Loading } from 'element-ui'

export default {
  name: 'orderInfo',
  props: {
    productModal: Object,
    tableScrollTop: Number,
    discountAmount: String || Number,
    tableDataList: Array,
    id: String,
  },
  watch: {
    discountAmount(val) {
      clearTimeout(this.changeTimer)
      this.changeTimer = setTimeout(() => {
        this.changeCount += 1
        this.notScroll = true
        this.getOrderCal(this.changeCount)
      }, 300)
    },
    productModal(val) {
      this.loadingInstance = Loading.service()
      cals.addProduct(val.product, val.modelType)
      this.changeCount = 0
      this.getOrderCal(this.changeCount)
    },
    tableDataList(val) {
      // console.log(val);
      const tableData = cals.handleCalData(val)
      this.tableData = JSON.parse(JSON.stringify(tableData))
    },
  },
  data() {
    return {
      changeCount: 1,
      notScroll: true,
      scrollTimer: null,
      changeTimer: null,
      tableList: [],
      tableData: [{ data: [] }],
      visible: false,
      promotionParams: null,
      promotionDict: {
        multipleable: [],
        firstOrder: [],
        promotionType: [],
        composeState: [],
        company: [],
        unit: [],
        unitType: [],
      },
      promotionCodes: [],
    }
  },
  components: {
    ShopsettleReplenDrawer,
    // PromotionDetail
  },
  mounted() {
    document.getElementById('app').scrollTop = 0
    this.getBatchDictSelect()
    this.getTableConfig()
    if (!this.id) {
      this.getProductList()
    }
  },
  methods: {
    //   获取列表配置
    getTableConfig() {
      const params = {
        functionCode: 'dms_order_settle_table',
        function_code: 'dms_order_settle_table',
        parentCode: 'CRM20210129000000857_1',
      }
      getTableConfig(params).then((res) => {
        const tableList = []
        let list = res.result.column.filter(
          (v) => v.visible && v.field !== 'ext24' && v.field !== 'ext26'
        )
        list.forEach((v) => {
          const rowData = v
          rowData.props = this.mateFieldType(rowData.field, rowData.title)
          if (!rowData.props.hidden) {
            tableList.push(rowData)
          }
        })
        this.tableList = tableList
      })
    },
    tableRowClassName({ row }) {
      if (row.calSucessMsg) {
        return 'warning-row'
      }
      return ''
    },
    mateFieldType(field, title) {
      let rowProps = {
        align: 'center',
        showOverflowTooltip: true,
        width: 88,
      }
      switch (field) {
        case 'promotionList':
          rowProps = {
            ...rowProps,
            width: '200px',
          }
          break
        case 'productName':
          rowProps = {
            ...rowProps,
            title: '商品名称/编码',
            width: '180px',
          }
          break
        case 'productNum':
          rowProps = {
            ...rowProps,
            width: '150px',
          }
          break
        case 'productCode':
          rowProps = {
            ...rowProps,
            hidden: true,
          }
          break
      }

      return rowProps
    },
    // 解析字段
    analysisField(scope, item) {
      if (item.field === 'lineType') {
        if (scope.row.lineType === '1') {
          return '政策商品'
        }
        if (scope.row.lineType === '2') {
          return '货补'
        }
        if (scope.row.disabled && scope.row.lineType === '3') {
          return '补货'
        }
        return '本品'
      }
      if (item.field === 'saleUnit') {
        return scope.row.saleUnitName
      }
      return scope.row[item.field]
    },
    getProductList() {
      cals.tableData = [
        {
          data: [],
        },
      ]
      const orderList = JSON.parse(Storage.l.get('orderList'))
      this.loadingInstance = Loading.service()
      cals.addProduct(orderList, '0')
      this.changeCount = 0
      this.getOrderCal(this.changeCount)
    },
    // 请求算价
    getOrderCal(changeCount = 0) {
      const groupItemVos = cals.handleSubmitCal()
      const params = {
        cusCode: Storage.l.get('customerCode'),
        discountAmount: this.discountAmount,
        fromType: 0,
        groupItemVos,
      }
      this.loadingInstance = Loading.service()
      getOrderCal(params)
        .then((res) => {
          if (this.loadingInstance) {
            this.loadingInstance.close()
          }
          if (res.success) {
            if (changeCount < this.changeCount) {
              return false
            }
            this.$emit('change', {
              calSucessMsg: '',
              calSucessFlag: false,
            })
            const tableData = cals.handleCalData(res.result.groupItemVos)
            this.tableData = JSON.parse(JSON.stringify(tableData))
            const {
              actualAmount,
              discountAmount,
              maxDiscountAmount,
              repAmount,
              promotionAmount,
              amount,
              weightOfKilogram,
            } = res.result
            this.$emit('quantityOrder', {
              actualAmount: actualAmount < 0 ? 0 : actualAmount,
              discountAmount: discountAmount <= 0 ? '' : discountAmount,
              maxDiscountAmount: maxDiscountAmount,
              repAmount: repAmount < 0 ? 0 : repAmount,
              promotionAmount: promotionAmount < 0 ? 0 : promotionAmount,
              amount: amount < 0 ? 0 : amount,
              weightOfKilogram: weightOfKilogram < 0 ? 0 : weightOfKilogram,
            })
          }
          if (res.result.calSucessFlag === 'N') {
            this.$emit('change', {
              calSucessMsg: res.result.calSucessMsg,
              calSucessFlag: 'N',
            })
            // if (res.result.calSucessMsg) this.$message.error(res.result.calSucessMsg)
          }
          if (!this.notScroll) {
            this.scrollToPromotion()
          }
          this.notScroll = false
          console.log(this.loadingInstance)

          if (this.loadingInstance) {
            console.log(123)

            this.loadingInstance.close()
          }
        })
        .catch((err) => {
          this.loadingInstance.close()
        })
    },
    // 获取数据字典
    getBatchDictSelect() {
      const params = [
        'yesOrNo',
        'promotion_type',
        'saleGoal_unitType',
        'saleCompany',
        'product_sale_unit',
        'unit_type',
      ]
      getBatchDictSelect(params).then((res) => {
        if (res.success) {
          this.promotionDict = {
            multipleable: res.result.yesOrNo,
            firstOrder: res.result.yesOrNo,
            composeState: res.result.yesOrNo,
            promotionType: res.result.promotion_type,
            company: res.result.saleCompany,
            unit: res.result.product_sale_unit,
            unitType: res.result.unit_type,
          }
          cals.promotionDict = this.promotionDict
        }
      })
    },
    //数量的加减
    AddorderList() {
      clearTimeout(this.changeTimer)
      this.changeTimer = setTimeout(() => {
        cals.tableData = cals.copyData(this.tableData)
        this.changeCount += 1
        this.notScroll = true
        this.getOrderCal(this.changeCount)
      }, 300)
    },
    getRowKey(row) {
      return row.id
    },
    // 获取选中的值
    handleSelectionChange(val) {
      console.log(val)
    },
    // 促销政策右侧显示弹框
    checkPromotion(scope, index) {
      console.log(scope)
      if (scope.row.disabled) {
        return false
      }
      this.handleIndex = {
        tableIndex: index,
        productIndex: scope.$index,
      }
      this.promotionParams = {
        accountCode: Storage.l.get('customerCode'),
        accountType: 'customer',
        saleProductVos: [{ productCode: scope.row.productCode }],
      }
      this.promotionCodes = scope.row.promotionVos.map(
        (item) => item.promotionCode
      )
      console.log(this.promotionCodes)
      cals.checkPromotion = cals.copyData(scope.row.promotionList)
      this.visible = true
    },
    showPromotion(scope, k, i) {
      const tableData = JSON.parse(JSON.stringify(this.tableData))
      tableData[k].data[scope.$index].promotionList[i].isShow = true
      this.tableData = tableData
    },
    hidePromotion(scope, k, i) {
      const tableData = JSON.parse(JSON.stringify(this.tableData))
      tableData[k].data[scope.$index].promotionList[i].isShow = false
      this.tableData = tableData
    },
    closeModal() {
      this.modalConfig.visible = false
    },
    closeTag(scope, k, i) {
      this.loadingInstance = Loading.service()
      cals.deletePromotion(scope.row, k, scope.$index, i)
      this.changeCount = 0
      this.getOrderCal(this.changeCount)
      // this.scrollToPromotion();
    },
    onModalOk(val) {
      this.loadingInstance = Loading.service()
      cals.handleBuyGifts(val, this.handleIndex)
      this.changeCount = 0
      this.getOrderCal(this.changeCount)
      this.handleClose()
    },
    scrollToPromotion() {
      this.$nextTick(() => {
        cals._self = this
        const scrollTop = cals.getScrollTop()
        let orgTop = document.getElementById('app').scrollTop
        let newTop = this.tableScrollTop + scrollTop - 120
        let step = Math.floor((newTop - orgTop) / 20)
        // console.log(step);
        const time = step > 20 || step < -20 ? 10 : 5
        if (step !== 0) {
          this.scrollTimer = setInterval(() => {
            orgTop += step
            if (step > 0) {
              if (orgTop > newTop) {
                orgTop = newTop
                // console.log(1);
                clearInterval(this.scrollTimer)
              }
            } else {
              if (orgTop < newTop) {
                orgTop = newTop
                // console.log(2);
                clearInterval(this.scrollTimer)
              }
            }
            document.getElementById('app').scrollTop = orgTop
          }, time)
        }
      })
    },
    // 关闭弹框（头部的X）
    handleClose() {
      this.visible = false
    },
    // 删除商品
    deleteProduct(scope, k) {
      let tableData = cals.deleteProduct(k, scope.$index)
      if (tableData.length > 0) {
        this.notScroll = true
        this.changeCount = 0
        this.getOrderCal(this.changeCount)
      } else {
        tableData = [{ data: [] }]
        this.tableData = tableData
        cals.tableData = tableData
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.orderInfo {
  .proPolicy {
    border: 1px solid pink;
    margin-bottom: 5px;
  }
}
/deep/.content-scrollbar {
  overflow-x: hidden;
  overflow-y: scroll;
  box-sizing: border-box;
  height: 100%;
  max-height: 400px;
}
.tag-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .pro-tag {
    margin-bottom: 6px;
    cursor: pointer;
  }
}
/deep/.warning-row {
  color: red;
}

/deep/div::-webkit-scrollbar {
  width: 5px;
}
.flexs {
  display: flex;
  justify-content: center;
}
// /deep/.el-table td,
// .el-table th.is-leaf {
//   border-bottom: 0;
// }
// 设置滚动条样式
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  z-index: 10;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #fafafa;
}
</style>
